module.exports = __webpack_public_path__ + "static/media/teacher-icon.0a3c0e8f.svg";